import { render, staticRenderFns } from "./blessing-data.vue?vue&type=template&id=20c3a28d&scoped=true&"
import script from "./blessing-data.vue?vue&type=script&lang=js&"
export * from "./blessing-data.vue?vue&type=script&lang=js&"
import style0 from "./blessing-data.vue?vue&type=style&index=0&id=20c3a28d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3a28d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c3a28d')) {
      api.createRecord('20c3a28d', component.options)
    } else {
      api.reload('20c3a28d', component.options)
    }
    module.hot.accept("./blessing-data.vue?vue&type=template&id=20c3a28d&scoped=true&", function () {
      api.rerender('20c3a28d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/marketingTools/live/activity/components/blessing-data.vue"
export default component.exports